import { Geopoint } from "./geopoint";

export class Station {
  id: number;
  name: string;

  constructor(s: any) {
    var self: any = this;
    for (let prop in s) {
      self[prop] = s[prop];
    }
  }
}

export class StationItem  {
  id : number;
  type : StationType
  name : string;
  numberOfAttachments : number;
  groupId : number;
  groupName : string;
  location : Geopoint;
  attachmentPointIds : Array<number>;
}

export class StationMap extends Station {
  latitude: number;
  longitude: number;
  groupName: string;
  countAP: number;
  freeAPs: any;
  associatedAPs: any;
  availableBikes: any;
  outOfOrderBikes : any;
  disabled : boolean;


  countAPs(): number {
    let total = 0;
    for (var type in this.freeAPs) {
      if (this.freeAPs.hasOwnProperty(type)) {
        total += this.freeAPs[type];
      }
    }
    for (var type in this.associatedAPs) {
      if (this.associatedAPs.hasOwnProperty(type)) {
        total += this.associatedAPs[type];
      }
    }
    return total;
  }

  countAvailableBikes(): number {
    let total = 0;
    for (var type in this.availableBikes) {
      if (this.availableBikes.hasOwnProperty(type)) {
        total += this.availableBikes[type];
      }
    }
    return total;
  }

  countOutOfOrder(): number {
    let total = 0;
    for (var type in this.outOfOrderBikes) {
      if (this.outOfOrderBikes.hasOwnProperty(type)) {
        total += this.outOfOrderBikes[type];
      }
    }
    return total;
  }
}

export enum StationType {
  MECHANIC= "MECHANIC", 
  ELECTRIC = "ELECTRIC",
  MIXED = "MIXED",
  EMPTY = "EMPTY"
}



// WEBPACK FOOTER //
// ./src/app/models/station.ts